import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button, Divider } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BsThreeDotsVertical, BiCheckDouble } from "react-icons/all";
import Chip from "../../assets/images/chip.png";
import straightVisaCard from "../../assets/images/straight_cards_32.png";
import "./index.css";
import info from "../../components/info";
import { useDispatch } from "react-redux";
import { UserAction } from "../../store/actions";
import CustomModal from "../modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";
import TextInput from "../../components/input/TextInput";

export default function CreditCard({
  filter,
  cardStyle,
  data,
  fromOrder,
  tickIcon,
  dotsIcon,
  paidText,
  shipVisaStyling,
  achStyling,
  radioValue,
  paidViaStyling,
  verifyBankAccount,
}) {
  const [isOpenModal, setOpenModal] = useState(false);
  const [achModal, setAchModal] = useState(false);
  const [achObj, setAchObj] = useState({
    first_deposit: "",
    second_deposit: "",
  });
  const [errors, setErrors] = useState({
    first_depositError: "",
    second_depositError: "",
  });
  const dispatch = useDispatch();
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      {achStyling && (
        <Menu.Item
          key="0"
          onClick={() => {
            setAchModal(true);
            setErrors({
              ...errors,
              first_depositError: "",
              second_depositError: "",
            });
          }}
          style={{ marginLeft: "-5px" }}
        >
          <span className="st-primary">Verify</span>
        </Menu.Item>
      )}
      <Menu.Item
        key="0"
        onClick={
          data?.default_source
            ? () => {
              info(
                "error",
                "Cannot delete default card! Make any other card your default and then delete this card"
              );
            }
            : () => setOpenModal(true)
        }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Delete</span>
      </Menu.Item>
    </Menu>
  );

  const onSubmitVerifyAccount = () => {
    const err = { ...errors };

    if (
      !achObj.first_deposit.trim().length ||
      !achObj.second_deposit.trim().length
    ) {
      if (!achObj.first_deposit.trim().length) {
        err.first_depositError = "First deposit is required";
      }
      if (!achObj.second_deposit.trim().length) {
        err.second_depositError = "Second deposit is required";
      }
      setErrors(err);
      return;
    }
    verifyBankAccount(achObj, data.id, () => setAchModal(false));
  };
  const onHandleAchChanged = (event) => {
    setAchObj({ ...achObj, [event.target.name]: event.target.value });
    setErrors({ ...errors, [`${event.target.name}Error`]: "" });
  };
  return (
    <Row justify={fromOrder ? "space-between" : "center"}>
      <Col xs={24} sm={24} md={24} lg={22} xl={22} className="custom">
        <Card className="ant-card-body" style={cardStyle}>
          {tickIcon && (
            <Row
              justify="start"
              style={{ display: tickIcon ? "block" : "none" }}
            >
              <Col>
                <BiCheckDouble
                  color="lightblue"
                  size={25}
                  style={{
                    visibility: !data?.default_source ? "hidden" : "visible",
                  }}
                />
              </Col>
            </Row>
          )}
          <Row justify="space-between" align="middle">
            {paidText ? <Col style={{ padding: "10px" }}>Paid Via</Col> : null}
            <Col
              xs={5}
              sm={2}
              md={6}
              lg={6}
              xl={6}
              style={{
                margin: shipVisaStyling
                  ? "8px -22px 0px 10px"
                  : "8px -35px 0px 10px",
                height: "28px",
                backgroundImage: !shipVisaStyling && `url(${Chip}) `,
                width: "28px",
                maxHeight: "28px",
                display: "flex",
                backgroundRepeat: "no-repeat",
                justifyContent: "end",
              }}
            >
              {shipVisaStyling && <img src={Chip} />}
            </Col>
            <Col
              xs={9}
              sm={3}
              md={8}
              lg={8}
              xl={6}
              style={{
                margin: shipVisaStyling
                  ? "8px -4px 0px 10px"
                  : " 10px 15px 2px 25px",
                height: shipVisaStyling ? "34px" : "33px",
                backgroundImage: `url(${straightVisaCard}) `,
                display: "inline-block",
                position: "relative",
                // backgroundPosition:
                //   data?.source?.object === "card" ? "-4px -78px" : "0px 0px",
                backgroundPosition:
                  data?.source?.brand === "MasterCard"
                    ? "0px -158px"
                    : data?.source?.brand === "American Express"
                      ? "0 -240px"
                      : data?.source?.brand === "Discover"
                        ? "0 -400px"
                        : data?.source?.brand === "Diners Club"
                          ? "0 -480px"
                          : data?.source?.brand === "JCB"
                            ? "0 -320px"
                            : data?.source?.brand === "UnionPay"
                              ? "0 0px"
                              : data?.source?.object === "card"
                                ? "-4px -78px"
                                : null,
                backgroundRepeat: "no-repeat",
                padding: "10px",
              }}
            ></Col>
            <Col
              xs={8}
              sm={4}
              md={10}
              lg={10}
              xl={12}
              style={{ margin: "8px -34px 0px 6px" }}
            >
              {dotsIcon && (
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  style={{
                    width: "40%",
                  }}
                >
                  <BsThreeDotsVertical className="pointer-cursor" />
                </Dropdown>
              )}
            </Col>
          </Row>
          <Row justify="center" align="middle">
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
              <h5
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "10px 0px 0px 0px",
                }}
              >
                {`**** **** **** ${data?.source?.last4 || 4242}`}
              </h5>
            </Col>
          </Row>
          <Row justify="space-between" style={{ marginTop: "10px" }}>
            <Col
              xl={!shipVisaStyling ? 12 : 6}
              sm={2}
              xs={2}
              md={12}
              lg={4}
              style={{
                paddingLeft: "5px",
                paddingBottom: "5px",
              }}
            >
              <span
                className="card-countryName"
                style={{
                  fontSize: "12px",
                  lineHeight: "15px",
                  fontWeight: 600,
                }}
              >
                {data?.source?.country || "US"}
              </span>
              <span
                className="card-country"
                style={{
                  fontSize: "12px",
                  lineHeight: "15px",
                  fontWeight: 600,
                  color: "#009688",
                }}
              >
                COUNTRY
              </span>
            </Col>
            <Col
              xs={10}
              sm={8}
              md={12}
              lg={8}
              xl={!shipVisaStyling ? 12 : 12}
              style={{
                paddingLeft: achStyling ? "0px" : "30px",
                paddingBottom: "5px",
              }}
            // style={{ margin: !shipVisaStyling ? "8px -35px 10px 10px" : null }}
            >
              <span
                style={{
                  fontSize: "12px",
                  lineHeight: "15px",
                  fontWeight: 600,
                }}
                className={
                  data?.source?.object === "card"
                    ? "card-expiryDate"
                    : "bank-expiryDate text-left three-dot"
                }
              >
                {data?.source?.object === "card" ? (
                  <span
                    style={{
                      fontSize: "12px",
                      lineHeight: "15px",
                      fontWeight: 600,
                      marginRight: "10px",
                    }}
                  >
                    {`${data?.source?.exp_month || 12}/${data?.source?.exp_year || 2023
                      }`}
                  </span>
                ) : (
                  data?.source?.bank_name
                )}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  lineHeight: "15px",
                  fontWeight: 600,
                }}
                className={
                  data?.source?.object === "card"
                    ? "card-expiry  "
                    : "bank-expiry text-left"
                }
              >
                {data?.source?.object === "card" ? "EXP" : "BANK NAME"}
              </span>
            </Col>
          </Row>
        </Card>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  dispatch(
                    UserAction.deleteCardReq(
                      data.id,
                      () => setOpenModal(false),
                      filter,
                      radioValue
                    )
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this card?"}</span>
          </Col>
        </Row>
      </CustomModal>

      <CustomModal
        visible={achModal}
        onCancelModal={() => setAchModal(false)}
        footer={[
          <Row justify="end">
            <Col
              className="d-flex justify-content-end"
              style={{ width: "100%", marginTop: "10px", marginBottom: "10px" }}
              span={12}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  border: "none",
                }}
                block
                onClick={() => {
                  onSubmitVerifyAccount();
                }}
              >
                Save
              </Button>
            </Col>
          </Row>,
        ]}
        width={400}
        className="ach-deposit-modal"
      >
        <Col xl={24}>
          <h5
            className="text-center st-primary"
            style={{
              color: "#47c9bf",
              fontSize: "24px",
              fontWeight: 300,
            }}
          >
            Verify Bank Account
          </h5>
          <Divider />
        </Col>
        <Col xl={24}>
          <form>
            <Row justify="center" gutter={[5, 30]}>
              <Col xl={22}>
                <TextInput
                  label="First Deposit"
                  name="first_deposit"
                  onChange={onHandleAchChanged}
                  value={achObj.first_deposit}
                  required
                />
                <Row className="text-right">
                  <Col
                    span={24}
                    className="text-right"
                    style={{ marginTop: "10px" }}
                  >
                    <span className="danger-color ">
                      {errors.first_depositError && errors.first_depositError}
                    </span>
                  </Col>
                </Row>
              </Col>

              <Col xl={22}>
                <TextInput
                  label="Second Deposit"
                  name="second_deposit"
                  onChange={onHandleAchChanged}
                  value={achObj.second_deposit}
                  required
                />
                <Row className="text-right">
                  <Col
                    span={24}
                    className="text-right"
                    style={{ marginTop: "10px" }}
                  >
                    <span className="danger-color">
                      {errors.second_depositError && errors.second_depositError}
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </form>
        </Col>
      </CustomModal>
    </Row>
  );
}
